import { z } from 'zod';
import parse from 'cron-parser';

export const BaseProcessingScheduleSchema = z.object({
  schedule: z.enum(['duration', 'cron', 'continuous']),
  duration: z.number().optional(),
  cron: z.string().optional(),
  durationUnit: z.enum(['m', 'h', 'd']),
});

export const ProcessingScheduleSchemaValidation: Parameters<
  (typeof BaseProcessingScheduleSchema)['superRefine']
> = [
  async (data, ctx) => {
    if (data.schedule === 'duration') {
      if (data.duration === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Duration is required',
          path: ['duration'],
        });
      } else if (data.duration <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Duration must be greater than 0',
          path: ['duration'],
        });
      }
    }

    if (data.schedule === 'cron' && !data.cron) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Cron is required',
        path: ['cron'],
      });
    }

    if (data.schedule === 'cron' && data.cron) {
      try {
        // Validate Quartz cron expression length
        const parts = data.cron.trim().split(' ');
        if (parts.length !== 6 && parts.length !== 7) {
          throw new Error('Invalid cron format');
        }

        parse.parseExpression(data.cron);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid cron expression',
          path: ['cron'],
        });
      }
    }
  },
];

export const ProcessingScheduleSchema =
  BaseProcessingScheduleSchema.superRefine(
    ...ProcessingScheduleSchemaValidation,
  );

export type ProcessingScheduleSchemaFormValues = z.infer<
  typeof ProcessingScheduleSchema
>;
